<template>
    <ul class="flex items-center space-x-5 text-base">
        <li>
            <NuxtLink
                id="BulkSearchHyperLink"
                class="text-xl py-5 font-bold whitespace-nowrap text-accent-secondary hover:text-accent-secondary hover:no-underline"
                :href="localePath('/bom/import')">
                {{ $t("Layout.BulkSearchLinkText") }}
            </NuxtLink>
        </li>
        <li v-if="faqEnabled">
            <a
                id="FAQLink"
                href="/faq"
                :title="$t('Layout.FAQLink')"
                class="text-white hover:text-white hover:no-underline">
                {{ $t("Layout.FAQLink") }}
            </a>
        </li>
        <li v-if="props.showApiMenu">
            <HeaderApiMenu />
        </li>
        <li>
            <DropdownMenu v-if="isAuthenticated">
                <HeaderMenuTrigger>
                    {{ $t("Layout.MyAccountLink") }}
                </HeaderMenuTrigger>
                <DropdownMenuContent>
                    <DropdownMenuItem v-for="link in accountMenuLinks" :key="link.to" as-child>
                        <NuxtLink :prefetch="false" v-bind="link">{{ link.title }}</NuxtLink>
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
            <NuxtLink
                v-else
                id="sign-in-button"
                :href="localePath('/sign-in')"
                class="text-white hover:text-white hover:no-underline"
                :title="$t('Global.SignInLabel')">
                {{ $t("Global.SignInLabel") }}
            </NuxtLink>
        </li>
    </ul>
</template>
<script setup lang="ts">
const localePath = useLocalePath();
const isAuthenticated = useStateIsAuthenticated();
const featureFlags = useStateFeatureFlags();
const accountMenuLinks = useAccountLinks();

const props = defineProps({
    showApiMenu: {
        type: Boolean,
        default: false,
    },
});

const faqEnabled = computed(() => featureFlags.value.FAQ_STATIC_SITE || false);
</script>
